// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.case-study {
  min-height: 100vh;
  background: #0a0a0f;
  color: #e8e8f0;
  padding: 4rem 1.5rem 6rem;
}
.case-study-inner {
  max-width: 920px;
  margin: 0 auto;
}

.back-link {
  display: inline-block;
  color: #7b6ef6;
  text-decoration: none;
  font-size: 0.95rem;
  margin-bottom: 2rem;
  transition: color 0.2s;
}
.back-link:hover {
  color: #a59cff;
}

.project-hero {
  display: flex;
  gap: 2rem;
  margin-bottom: 3rem;
  align-items: flex-start;
}
.project-hero-logo {
  width: 100px;
  height: 100px;
  border-radius: 18px;
  flex-shrink: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.project-hero-text {
  flex: 1 1;
}
.project-hero-eyebrow {
  font-size: 0.85rem;
  color: #7a7a9a;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 0.6rem;
}
.project-hero h1 {
  font-size: 2.4rem;
  margin: 0 0 0.6rem;
  line-height: 1.15;
  color: #ffffff;
}
.project-hero-tagline {
  font-size: 1.15rem;
  color: #c4c4d4;
  margin-bottom: 1rem;
  line-height: 1.5;
}
.project-hero-role {
  font-size: 0.95rem;
  color: #9a9ab0;
  margin-bottom: 1.2rem;
}
.project-hero-links {
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
}
.project-hero-link {
  display: inline-block;
  background: rgba(123, 110, 246, 0.15);
  color: #a59cff;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  text-decoration: none;
  font-size: 0.9rem;
  border: 1px solid rgba(123, 110, 246, 0.35);
  transition: background 0.2s, transform 0.2s;
}
.project-hero-link:hover {
  background: rgba(123, 110, 246, 0.25);
  transform: translateY(-1px);
}

.project-video {
  margin-bottom: 3rem;
}
.project-video h2 {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #7a7a9a;
  margin-bottom: 1rem;
}
.project-video-frame {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.project-video-frame iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.project-video-caption {
  font-size: 0.85rem;
  color: #7a7a9a;
  text-align: center;
  margin-top: 0.6rem;
  font-style: italic;
}

.project-tech {
  margin-bottom: 3rem;
}
.project-tech h2 {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #7a7a9a;
  margin-bottom: 1rem;
}
.project-tech-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.project-tech-tag {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #c4c4d4;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  font-size: 0.85rem;
  font-family: "DM Mono", "JetBrains Mono", monospace;
}

.project-section {
  margin-bottom: 2.5rem;
}
.project-section h2 {
  font-size: 1.4rem;
  color: #ffffff;
  margin: 0 0 0.8rem;
  line-height: 1.3;
}
.project-section p {
  font-size: 1.02rem;
  line-height: 1.75;
  color: #c4c4d4;
  margin: 0;
}
.project-section.reflection {
  background: rgba(91, 79, 224, 0.06);
  border-left: 3px solid #7b6ef6;
  padding: 1.5rem 1.8rem;
  border-radius: 0 12px 12px 0;
  margin-bottom: 3rem;
}
.project-section.reflection h2::before {
  content: "✶ ";
  color: #7b6ef6;
}

.project-screenshots {
  margin-top: 3rem;
}
.project-screenshots h2 {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #7a7a9a;
  margin-bottom: 1.2rem;
}
.project-screenshots .screenshot-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1.5rem;
  gap: 1.5rem;
}
.project-screenshots .screenshot {
  margin: 0;
}
.project-screenshots .screenshot img {
  width: 100%;
  height: auto;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  display: block;
}
.project-screenshots .screenshot figcaption {
  font-size: 0.85rem;
  color: #7a7a9a;
  text-align: center;
  margin-top: 0.6rem;
  font-style: italic;
}

.case-study-footer {
  margin-top: 4rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

@media (max-width: 640px) {
  .case-study {
    padding: 2rem 1rem 4rem;
  }
  .project-hero {
    flex-direction: column;
    gap: 1.2rem;
  }
  .project-hero h1 {
    font-size: 1.8rem;
  }
  .project-hero-logo {
    width: 72px;
    height: 72px;
  }
  .project-section h2 {
    font-size: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/projectDetail/ProjectDetail.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAEF;AAAE;EACE,gBAAA;EACA,cAAA;AAEJ;;AAEA;EACE,qBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;AAAJ;AAGE;EACE,SAAA;AADJ;AAIE;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,cAAA;EACA,qBAAA;AALJ;AAQE;EACE,aAAA;EACA,WAAA;EACA,eAAA;AANJ;AASE;EACE,qBAAA;EACA,qCAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,2CAAA;EACA,2CAAA;AAPJ;AASI;EACE,qCAAA;EACA,2BAAA;AAPN;;AAYA;EACE,mBAAA;AATF;AAWE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AATJ;AAYE;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,yCAAA;AAVJ;AAYI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAVN;AAcE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAZJ;;AAgBA;EACE,mBAAA;AAbF;AAeE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAdJ;AAiBE;EACE,qCAAA;EACA,2CAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mDAAA;AAfJ;;AAmBA;EACE,qBAAA;AAhBF;AAkBE;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAjBJ;AAoBE;EACE,mCAAA;EACA,8BAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,cAAA;AAlBN;;AAuBA;EACE,gBAAA;AApBF;AAsBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,qBAAA;AApBJ;AAuBE;EACE,aAAA;EACA,0BAAA;EACA,gBAAA;EAAA,WAAA;AArBJ;AAwBE;EACE,SAAA;AAtBJ;AAwBI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,yCAAA;EACA,cAAA;AAtBN;AAyBI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAvBN;;AA4BA;EACE,gBAAA;EACA,iBAAA;EACA,+CAAA;AAzBF;;AA4BA;EACE;IACE,uBAAA;EAzBF;EA4BA;IACE,sBAAA;IACA,WAAA;EA1BF;EA4BE;IACE,iBAAA;EA1BJ;EA6BE;IACE,WAAA;IACA,YAAA;EA3BJ;EA+BA;IACE,iBAAA;EA7BF;AACF","sourcesContent":[".case-study {\n  min-height: 100vh;\n  background: #0a0a0f;\n  color: #e8e8f0;\n  padding: 4rem 1.5rem 6rem;\n\n  &-inner {\n    max-width: 920px;\n    margin: 0 auto;\n  }\n}\n\n.back-link {\n  display: inline-block;\n  color: #7b6ef6;\n  text-decoration: none;\n  font-size: 0.95rem;\n  margin-bottom: 2rem;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #a59cff;\n  }\n}\n\n.project-hero {\n  display: flex;\n  gap: 2rem;\n  margin-bottom: 3rem;\n  align-items: flex-start;\n\n  &-logo {\n    width: 100px;\n    height: 100px;\n    border-radius: 18px;\n    flex-shrink: 0;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  }\n\n  &-text {\n    flex: 1;\n  }\n\n  &-eyebrow {\n    font-size: 0.85rem;\n    color: #7a7a9a;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    margin-bottom: 0.6rem;\n  }\n\n  h1 {\n    font-size: 2.4rem;\n    margin: 0 0 0.6rem;\n    line-height: 1.15;\n    color: #ffffff;\n  }\n\n  &-tagline {\n    font-size: 1.15rem;\n    color: #c4c4d4;\n    margin-bottom: 1rem;\n    line-height: 1.5;\n  }\n\n  &-role {\n    font-size: 0.95rem;\n    color: #9a9ab0;\n    margin-bottom: 1.2rem;\n  }\n\n  &-links {\n    display: flex;\n    gap: 0.8rem;\n    flex-wrap: wrap;\n  }\n\n  &-link {\n    display: inline-block;\n    background: rgba(123, 110, 246, 0.15);\n    color: #a59cff;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    text-decoration: none;\n    font-size: 0.9rem;\n    border: 1px solid rgba(123, 110, 246, 0.35);\n    transition: background 0.2s, transform 0.2s;\n\n    &:hover {\n      background: rgba(123, 110, 246, 0.25);\n      transform: translateY(-1px);\n    }\n  }\n}\n\n.project-video {\n  margin-bottom: 3rem;\n\n  h2 {\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: #7a7a9a;\n    margin-bottom: 1rem;\n  }\n\n  &-frame {\n    position: relative;\n    width: 100%;\n    padding-bottom: 56.25%; // 16:9 aspect ratio\n    background: #000;\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      border: 0;\n    }\n  }\n\n  &-caption {\n    font-size: 0.85rem;\n    color: #7a7a9a;\n    text-align: center;\n    margin-top: 0.6rem;\n    font-style: italic;\n  }\n}\n\n.project-tech {\n  margin-bottom: 3rem;\n\n  h2 {\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: #7a7a9a;\n    margin-bottom: 1rem;\n  }\n\n  &-tags {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  &-tag {\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #c4c4d4;\n    padding: 0.35rem 0.8rem;\n    border-radius: 999px;\n    font-size: 0.85rem;\n    font-family: 'DM Mono', 'JetBrains Mono', monospace;\n  }\n}\n\n.project-section {\n  margin-bottom: 2.5rem;\n\n  h2 {\n    font-size: 1.4rem;\n    color: #ffffff;\n    margin: 0 0 0.8rem;\n    line-height: 1.3;\n  }\n\n  p {\n    font-size: 1.02rem;\n    line-height: 1.75;\n    color: #c4c4d4;\n    margin: 0;\n  }\n\n  &.reflection {\n    background: rgba(91, 79, 224, 0.06);\n    border-left: 3px solid #7b6ef6;\n    padding: 1.5rem 1.8rem;\n    border-radius: 0 12px 12px 0;\n    margin-bottom: 3rem;\n\n    h2::before {\n      content: \"✶ \";\n      color: #7b6ef6;\n    }\n  }\n}\n\n.project-screenshots {\n  margin-top: 3rem;\n\n  h2 {\n    font-size: 1rem;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: #7a7a9a;\n    margin-bottom: 1.2rem;\n  }\n\n  .screenshot-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .screenshot {\n    margin: 0;\n\n    img {\n      width: 100%;\n      height: auto;\n      border-radius: 12px;\n      border: 1px solid rgba(255, 255, 255, 0.08);\n      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n      display: block;\n    }\n\n    figcaption {\n      font-size: 0.85rem;\n      color: #7a7a9a;\n      text-align: center;\n      margin-top: 0.6rem;\n      font-style: italic;\n    }\n  }\n}\n\n.case-study-footer {\n  margin-top: 4rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n@media (max-width: 640px) {\n  .case-study {\n    padding: 2rem 1rem 4rem;\n  }\n\n  .project-hero {\n    flex-direction: column;\n    gap: 1.2rem;\n\n    h1 {\n      font-size: 1.8rem;\n    }\n\n    &-logo {\n      width: 72px;\n      height: 72px;\n    }\n  }\n\n  .project-section h2 {\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
